// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__cx8n7","label":"LabeledBox_label__2uePH"};